import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const IMPORT_JOB_STORAGE_KEY = 'menuCloudImportJob';
const CHECK_JOB_STORAGE_KEY = 'menuCloudCheckJob';

const statusVersion = () => {
	return Client.get(`/gateway/Status/Version`);
};

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menus`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menus`, payload);
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/menus/${id}`);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/menus/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/menus/${id}`, payload);
};

const importItems = (merchantId, formData, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/import`, formData, payload, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		timeout: 300000,
	});
};

const getImportJob = (merchantId, jobId) => {
	return Client.get(
		`${baseUrl}/${merchantId}/import/jobs/${jobId}`,
		{},
		{
			timeout: 60000,
		}
	);
};

const exportMenu = (merchantId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/export`,
		payload,
		{
			responseType: 'blob',
			timeout: 300000,
		},
		{
			headers: {
				'Content-Type': 'application/octet-stream',
			},
		}
	);
};

const startMenuCheck = (merchantId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/check`,
		payload,
		{},
		{
			timeout: 60000,
		}
	);
};

const getMenuCheckJob = (merchantId, jobId) => {
	return Client.get(
		`${baseUrl}/${merchantId}/check/jobs/${jobId}`,
		{},
		{
			timeout: 60000,
		}
	);
};

const saveImportJobRef = (menuId, merchantId, jobId) => {
	try {
		localStorage.setItem(
			IMPORT_JOB_STORAGE_KEY,
			JSON.stringify({ menuId, merchantId, jobId, savedAt: Date.now() })
		);
	} catch (e) {
		// ignore storage errors
	}
};

const loadImportJobRef = (menuId, merchantId) => {
	try {
		const raw = localStorage.getItem(IMPORT_JOB_STORAGE_KEY);
		if (!raw) return null;
		const ref = JSON.parse(raw);
		if (
			String(ref.menuId) === String(menuId) &&
			ref.merchantId === merchantId
		) {
			return ref.jobId;
		}
	} catch (e) {
		// ignore
	}
	return null;
};

const clearImportJobRef = () => {
	try {
		localStorage.removeItem(IMPORT_JOB_STORAGE_KEY);
	} catch (e) {
		// ignore
	}
};

const saveCheckJobRef = (menuId, merchantId, jobId) => {
	try {
		localStorage.setItem(
			CHECK_JOB_STORAGE_KEY,
			JSON.stringify({ menuId, merchantId, jobId, savedAt: Date.now() })
		);
	} catch (e) {
		// ignore storage errors
	}
};

const loadCheckJobRef = (menuId, merchantId) => {
	try {
		const raw = localStorage.getItem(CHECK_JOB_STORAGE_KEY);
		if (!raw) return null;
		const ref = JSON.parse(raw);
		if (
			String(ref.menuId) === String(menuId) &&
			ref.merchantId === merchantId
		) {
			return ref.jobId;
		}
	} catch (e) {
		// ignore
	}
	return null;
};

const clearCheckJobRef = () => {
	try {
		localStorage.removeItem(CHECK_JOB_STORAGE_KEY);
	} catch (e) {
		// ignore
	}
};

export default {
	statusVersion,
	list,
	find,
	create,
	update,
	remove,
	importItems,
	getImportJob,
	exportMenu,
	startMenuCheck,
	getMenuCheckJob,
	saveImportJobRef,
	loadImportJobRef,
	clearImportJobRef,
	saveCheckJobRef,
	loadCheckJobRef,
	clearCheckJobRef,
};
